import React from "react";
import "./testimonials.css";
import { Data } from "./Data";

// Import Swiper React components                                             //Swiper JS - slider library
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper";

const Testimonials = () => {
   return(
      <section className="testimonial container section"> 
         <h2 className="section__title">My client says</h2>
         <span className="section__subtitle">Testimonial</span>
                                                                              {/*Swiper JS - slider library*/}
         <Swiper className="testimonial__container"                           
            // slidesPerView={1}
            loop={true}
            grabCursor={true}
            spaceBetween={24}
            pagination={{
               clickable: true,
            }}
            breakpoints={{
               576: {
                  slidesPerView: 2,
                  // spaceBetween: 20,
               },
               768: {
                  slidesPerView: 2,
                  spaceBetween: 48,
               },
               //  1024: {
               //    slidesPerView: 5,
               //    spaceBetween: 50,
               //  },
            }}
            modules={[Pagination]}
            //  className="mySwiper"
         >                         
            {Data.map(({id, image, title, relationship, description, location}) => {
               return(
                  <SwiperSlide className="testimonial__card" key={id}>        {/*Swiper JS - slider library*/}
                     <a href="https://www.linkedin.com/in/stuart-daniells/" target="_blank" rel="noreferrer">
                        <img src={image} alt="" className="testimonial__img"/>
                     </a>

                     <h2 className="testimonial__name">{title}</h2>
                     <h3 className="testimonial__name">{relationship}</h3><br/>
                     <p className="testimonial__description">{description}</p> <br/>
                     <p className="testimonial__description">{location}</p>
                  </SwiperSlide>
               );
            })}
         </Swiper>
      </section>
   );
};

export default Testimonials;